import { render, staticRenderFns } from "./ApplicationForm.vue?vue&type=template&id=a084c10c&"
import script from "./ApplicationForm.vue?vue&type=script&lang=ts&"
export * from "./ApplicationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports